import type { ReactNode } from 'react'
import { TopBarComponent } from './top-bar/top-bar.component'
import { SidebarComponent } from './sidebar/sidebar.component'
import { CommandPaletteComponent } from '@core/infra/command-palette/command-palette.component'

type Props = {
  page: ReactNode
}

export const ShellComponent = ({ page }: Props) => {
  return (
    <div className="flex flex-col h-screen">
      <TopBarComponent />
      <div className="flex flex-1 min-h-0 relative">
        <SidebarComponent />
        <main className="flex-1 overflow-auto bg-shell-surface p-4 text-shell-ink">{page}</main>
      </div>
      <CommandPaletteComponent />
    </div>
  )
}
